export const UPDATE_EMAIL_TEMPLATE = 'UPDATE_EMAIL_TEMPLATE'
export const ADD_EMAIL_TEMPLATE = `ADD_EMAIL_TEMPLATE`
export const CREATE_EMAIL = 'CREATE_EMAIL'

export const EMAIL_TEMPLATE = 'email_template'
export const ALL_KEYS = [EMAIL_TEMPLATE]



// WEBPACK FOOTER //
// ./src/pages/newsbrief/email-template/constants.ts